export const mapOrderDeliveryStatus = (orderDeliveryStatus) => {
  switch (orderDeliveryStatus) {
    case 'NOT_ASSIGNED':
      return 'PROCESSING';
    case 'NOT_ACCEPTED':
    case 'NOT_STARTED_YET':
    case 'STARTED':
      return 'PREPARING';

    case 'PICKED_UP':
    case 'READY_TO_DELIVER':
      return 'OUT FOR DELIVERY';

    case 'ALREADY_DELIVERED':
      return 'COMPLETED';

    case 'FAILED_DELIVERY':
    case 'INCOMPLETE':
      return 'FAILED';

    default:
      return 'UNKNOWN';
  }
};

export const mapOrderDeliveryStatusDescription = (orderDeliveryStatus) => {
  switch (orderDeliveryStatus) {
    case 'PROCESSING':
      return 'Your order is being prepared for pickup.';
    case 'PREPARING':
      return 'We’re getting your order ready.';
    case 'OUT FOR DELIVERY':
      return 'Your order is on its way to you.';
    case 'COMPLETED':
      return 'Your order has been delivered.';
    case 'FAILED':
      return 'There was an issue delivering your order.';
    case 'UNKNOWN':
      return 'We’re currently checking your order status.';
    default:
      return '-';
  }
};
